module.exports = __webpack_public_path__ + "static/media/97.04a1e6c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/97.jpg
// module id = 1029
// module chunks = 0